module.exports = __webpack_public_path__ + "static/Familiar-62ca629bdbd953383e7c60fd4c7795a4.jpeg";